<template>
  <div>
    <base-crud
      crudName="Servidores"
      newText="Novo Registro"
      :table="projectTable"
      :columns="columns"
      :options="options"
      :endPoint="endPoint"
      :enableAdd="true"
      :enableEdit="true"
      :enableDelete="true"
      :enableView="true"
    >
    </base-crud>
  </div>
</template>

<script>
import BaseCrud from "../Base/BaseCrud";


export default {
  data: function () {
    let self = this;
    return {
      projectstatuses: [],
      dataForm: {},
      projectTable: "projectTable",
      users: [],
      pages: [],
      url: "",
      columns: ["id", "name", "hostname", "ip_address", "actions"],
      tableData: ["id"],
      debounce: 800,
      options: {
        filterByColumn: true,
        filterable: [
          "id",
          "name",
          "hostname",
          "ip_address",
          "status",
        ],
        sortable: [
          "id",
          "name",
          "hostname",
          "ip_address",
          "status",
        ],
        pagination: { chunk: 10, dropdown: false, nav: "scroll" },
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        headings: {
          id: "ID",
          name: "Nome",
          hostname: "Hostname",
          ip_address: "IP",
          status: "Status",
          actions: "Ações",
        },
        requestFunction: function (data) {
          let requestData = {};

          let query = this.$parent.$parent.query(data.query);
          requestData.params = data;
          requestData.params.query = "";
          requestData.params.with = [];

          return this.$http.get(this.url + "?" + query, requestData).catch(
            function (e) {
              this.dispatch("error", e);
            }.bind(this)
          );
        },
      },
      endPoint: "servers/",
    };
  },
  methods: {
    query: function (query) {
      let columns = {
        id: "id",
        name: "name",
        hostname: "hostname",
        ip_address: "ip_address",
        status: "status",
      };
      let filters = "";
      $.each(query, function (index, value) {
        filters += columns[index] + "=" + value + "&";
      });
      return filters;
    },
  },
  mounted() {
    let self = this;
    this.$http
      .get(this.$store.getters.api + "servers?paginated=false")
      .then((response) => {
        self.servers = response.data.data;
      });
  },
  components: {
    BaseCrud,
  },
};
</script>

<style scoped>
.VuePagination {
  text-align: center;
}
</style>